import { formatDate, registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { Pipe, PipeTransform } from '@angular/core';

registerLocaleData(localePt, 'pt-BR');

export type FormatoDataNoticia = 'curta' | 'completa';

const MASCARAS: Record<FormatoDataNoticia, string> = {
  curta: 'dd MMM yyyy',
  completa: "d 'de' MMMM 'de' y",
};

function maiuscula(palavra: string): string {
  return palavra.charAt(0).toUpperCase() + palavra.slice(1);
}

/**
 * A data da notícia como o portal sempre exibiu: `12 Jun 2026` nos cards e
 * `12 de Junho de 2026` no detalhe. O `pt-BR` do Angular devolve o mês em minúscula e o
 * abreviado com ponto (`12 jun. 2026`), daí o ajuste de caixa depois do `formatDate`.
 */
export function formatarDataNoticia(valor: string | null | undefined, formato: FormatoDataNoticia = 'curta'): string {
  if (!valor) return '';

  const texto = formatDate(valor, MASCARAS[formato], 'pt-BR');

  if (formato === 'curta') {
    const [dia, mes, ano] = texto.split(' ');
    return `${dia} ${maiuscula(mes.replace('.', ''))} ${ano}`;
  }

  return texto
    .split(' ')
    .map((parte) => (parte === 'de' ? parte : maiuscula(parte)))
    .join(' ');
}

@Pipe({ name: 'dataNoticia' })
export class DataNoticiaPipe implements PipeTransform {
  transform(valor: string | null | undefined, formato: FormatoDataNoticia = 'curta'): string {
    return formatarDataNoticia(valor, formato);
  }
}
